/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const messageTokens = {
  WrapperBackgroundColorOutbound: '#f4f4f4',
  WrapperBackgroundColorInbound: '#eaf0f8',
  WrapperBorderColorOutbound: '#dedfdf',
  WrapperBorderColorInbound: '#c0d1e9',
  WrapperBorderStyleDefault: 'solid',
  WrapperBorderWidthDefault: '1px',
  WrapperBorderRadiusDefault: '12px',
  WrapperSpacingHorizontal: '20px',
  WrapperSpacingVertical: '20px',
  AttachmentBackgroundColorDefault: '#fbf8f7',
  AttachmentBorderColorDefault: '#dedfdf',
  AttachmentBorderStyleDefault: 'solid',
  AttachmentBorderWidthDefault: '1px',
  AttachmentBorderRadiusDefault: '4px',
  AttachmentSpacingHorizontal: '4px',
  AttachmentSpacingVertical: '8px',
  AttachmentSpacingGapIcon: '4px',
  AttachmentSpacingGapWrapper: '8px',
  InfoSpacingHorizontal: '8px',
  InfoFontSizeDefault: '12px',
  InfoFontColorDefault: '#656b6b',
} as const;
